import React, { FC } from "react";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/redux/currentUser/selector";
import { getDealInitiator } from "src/page-components/cabinet/deals/constants";
import { ButtonChat } from "src/components/ButtonChat";
import { getItemPath } from "src/utils/getItemPath";
import { getImageUrl } from "src/utils/getImageUrl";
import { PATHNAMES } from "src/constants/routes";
import { IDeal, Statuses } from "src/@types/deals";
import { DealHead } from "./DealHead";
import { UserLabel } from "./UserLabel";
import { StatusIndicator } from "./StatusIndicator";

const ACTIVE_STATUSES = [
  Statuses.NEW_REQUEST,
  Statuses.IN_PROGRESS,
  Statuses.PENDING,
];

export const DealCard: FC<IDeal> = ({
  id,
  buyer,
  seller,
  status,
  clone,
  inquiry,
  chat,
}) => {
  const user = useAppSelector(selectCurrentUser);
  const visibleUser = user?.host?.id === seller?.host?.id ? buyer : seller;

  const isActiveStatus = ACTIVE_STATUSES.includes(status);
  const userFullName = `${visibleUser.host.first_name} ${visibleUser.host.last_name}`;

  const hrefDeal =
    isActiveStatus && getItemPath(PATHNAMES.DEAL_ITEM, { deal: id });

  return (
    <div className="bg-purple-lighter md:bg-white-pink border border-black-base/20 rounded-20 overflow-hidden">
      <DealHead
        href={hrefDeal}
        isActiveStatus={isActiveStatus}
        {...getDealInitiator(inquiry, clone)}
      />

      <div className="flex flex-col md:flex-row items-center justify-start gap-3 md:gap-5 p-5 pt-0 md:pt-5">
        <UserLabel
          userRole={visibleUser.host.role}
          userName={userFullName}
          avatarUrl={getImageUrl(visibleUser.host.avatarUrl)}
          userId={visibleUser.user}
          isLabelOutside
        />

        <StatusIndicator
          status={status}
          href={hrefDeal}
          isActiveStatus={isActiveStatus}
        />
        <ButtonChat chatId={chat} isActiveStatus={isActiveStatus} />
      </div>
    </div>
  );
};
